import { withUiVersion } from 'hoc/withUiVersion';
import LegacyLayout from './LegacyLayout';
import Layoutv2 from './Layoutv2';

const Layout = withUiVersion(LegacyLayout, Layoutv2);

export default Layout;
